import React, { useEffect } from "react";

const GoogleReviewsWidget = () => {
  useEffect(() => {
    // Cargar el script de Elfsight solo una vez
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Limpieza: eliminar el script si el componente se desmonta
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="reviews-section">
      <h2 className="reviews-title">Lo que dicen nuestros clientes</h2>

      {/* Widget de Elfsight */}
      <div
        className="elfsight-app-ed5f898a-0167-483e-9be0-513d9bd22012"
        data-elfsight-app-lazy
      ></div>
    </div>
  );
};

export default GoogleReviewsWidget;
